var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacilityMeetingRoom = function SvgFacilityMeetingRoom(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 -960 960 960"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M120-120v-60h92v-660h390v45h147v615h91v60H689v-615h-87v615zm152-660v600zm179 340q17 0 28.5-11.5T491-480t-11.5-28.5T451-520t-28.5 11.5T411-480t11.5 28.5T451-440M272-180h270v-600H272z"
  })));
};
export default SvgFacilityMeetingRoom;